// extracted by mini-css-extract-plugin
export var addressFields = "_mk-0";
export var animationContainer = "_mk-1";
export var footer = "_mk-2";
export var lineItems = "_mk-3";
export var modalContent = "_mk-4";
export var orderName = "_mk-5";
export var strong = "_mk-6";
export var warning = "_mk-7";